const CONTROLLER = "/members/:user_id";
const PATHS = {
  FOLLOW_USER: "/follow",
  ACCEPT_FOLLOW_REQUEST: "/accept",
  UNFOLLOW_USER: "/follow",
  GET_USER_FOLLOWERS: "/followers",
  GET_USER_FOLLOWERS_COUNT: "/followers/count",
  IS_USER_FOLLOWED_BY_REQUESTER: "/followed",
  GET_USER_FOLLOW_REQUESTS: "/requests",
  GET_USER_FOLLOWING: "/following",
};

export const MembersApiRoutesNames = Object.fromEntries(
  (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k])
) as {
  [K in keyof typeof PATHS]: K;
};

export const FollowApiRoutes = {
  CONTROLLER,
  PATHS,
  FOLLOW_USER: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.FOLLOW_USER}`.replace(":user_id", String(user_id)),
  ACCEPT_FOLLOW_REQUEST: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.ACCEPT_FOLLOW_REQUEST}`.replace(
      ":user_id",
      String(user_id)
    ),
  UNFOLLOW_USER: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.UNFOLLOW_USER}`.replace(":user_id", String(user_id)),
  GET_USER_FOLLOWERS: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.GET_USER_FOLLOWERS}`.replace(
      ":user_id",
      String(user_id)
    ),
  GET_USER_FOLLOWERS_COUNT: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.GET_USER_FOLLOWERS_COUNT}`.replace(
      ":user_id",
      String(user_id)
    ),
  IS_USER_FOLLOWED_BY_REQUESTER: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.IS_USER_FOLLOWED_BY_REQUESTER}`.replace(
      ":user_id",
      String(user_id)
    ),
  GET_USER_FOLLOW_REQUESTS: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.GET_USER_FOLLOW_REQUESTS}`.replace(
      ":user_id",
      String(user_id)
    ),
};
